import { Component, computed, inject, input, output, signal } from '@angular/core';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { TranslatePipe } from '@ngx-translate/core';
import { AvatarComponent } from '../../molecules/avatar/avatar.component';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';
import { OcpImageComponent } from '../../atoms/image/image.component';
import { NgTemplateOutlet } from '@angular/common';
import { ViewportService } from 'shared';

@Component({
  selector: 'ocp-project-card',
  imports: [
    HlmCardImports,
    OcpImageComponent,
    TranslatePipe,
    AvatarComponent,
    ThemedIconComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './project-card.component.html',
  styleUrl: './project-card.component.scss',
})
export class ProjectCardComponent {
  name = input.required<string>();
  selected = input(false);
  thumbnail = input<string | undefined>(undefined);
  teamName = input<string | undefined>(undefined);
  teamId = input<string | undefined>(undefined);
  modelsCount = input<number | undefined>(undefined);
  tasksCount = input<number | undefined>(undefined);
  projectSelect = output<void>();

  protected readonly isMobileView = inject(ViewportService).isMobile;

  protected readonly teamInitial = computed(() => this.teamName()?.charAt(0)?.toUpperCase() ?? '');
  protected readonly thumbnailError = signal(false);
  protected readonly modelsCountComputed = computed(() => this.modelsCount() ?? 0);
  protected readonly tasksCountComputed = computed(() => this.tasksCount() ?? 0);

  onThumbnailError(): void {
    this.thumbnailError.set(true);
  }
}
